import type { FC } from 'react';
import { cx } from '@linaria/atomic';
import { Heading } from '@frontend/design-system';
import { styles } from '../panel-feature-promotion-banner.styles';
import type { PanelFeaturePromotionBannerHeaderProps } from '../panel-feature-promotion-banner.types';

export const PanelFeaturePromotionBannerHeader: FC<PanelFeaturePromotionBannerHeaderProps> = ({
  children,
  leading,
  trailing,
  headingLevel = 3,
  className,
  testId,
}) => {
  return (
    <header className={cx(styles.header, className)} data-testid={testId}>
      <div className={styles.headerStart}>
        {leading && <span className={styles.headerLeading}>{leading}</span>}
        <Heading level={headingLevel} className={styles.headerTitle}>
          {children}
        </Heading>
      </div>
      {trailing && <span className={styles.headerTrailing}>{trailing}</span>}
    </header>
  );
};
